"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = require("prop-types");
var react_highlight_words_1 = __importDefault(require("react-highlight-words"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_acdc_1 = require("@seaweb/react-acdc");
var StyledHighlighter = styled_1.default(react_highlight_words_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .coral-select-highlighter__highlight {\n    background-color: transparent;\n\n    ", "\n  }\n"], ["\n  .coral-select-highlighter__highlight {\n    background-color: transparent;\n\n    ",
    "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.colors.primary);
});
var SelectHighlighter = function (_a) {
    var text = _a.text, props = __rest(_a, ["text"]);
    var value = react_acdc_1.useAcdcContext().state.value;
    return (react_1.default.createElement(StyledHighlighter, __assign({ textToHighlight: text, searchWords: ("" + value).split(' '), autoEscape: true, highlightClassName: "coral-select-highlighter__highlight" }, props)));
};
if (process.env.NODE_ENV !== 'production') {
    SelectHighlighter.propTypes = {
        text: prop_types_1.string.isRequired,
    };
}
exports.default = react_1.memo(SelectHighlighter);
var templateObject_1, templateObject_2;
